import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { DialogBase, DiscountValueType, RentalInfo } from 't4core';
import { CampaignInfo, GenerateVoucherResult } from '../../../../../projects/t4core/src/public-api';
import { RentalDialog } from '../../../../t4common/';

@Component({
  selector: 'createVoutchesDialog',
  templateUrl: 'createVouchersDialog.html',
})

export class CreateVouchersResultDialog extends DialogBase {

  voutherscount = new FormControl('', [Validators.required, Validators.min(0), Validators.pattern(/^(|[1-9]\d*)?$/)]);

  amountValue = new FormControl('', [Validators.required, Validators.min(0), Validators.pattern(/^(0|[1-9]\d*)?$/)]);
  procentValue = new FormControl('', [Validators.required, Validators.min(0), Validators.max(100), Validators.pattern(/^(0|[1-9]\d*)?$/)]);
  timeValue = new FormControl('', [Validators.required, Validators.min(0), Validators.pattern(/^(0|[1-9]\d*)?$/)]);


  public counter: number;
  public partner: string;

  public campaign: CampaignInfo;

  public value: number;
  public valueType: DiscountValueType;

  constructor(
    public dialogRef: MatDialogRef<CreateVouchersResultDialog>, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("CreateVouchersDialog");

    this.campaign = data;

    this.counter = 1; 
    this.value = this.campaign.Value;
    this.valueType = this.campaign.ValueType;
  }


  public async generateVouchers() {

    this.campaign.Value = this.value; 

    await this.dialogRef.close("T4.Campaigns.CreateVouchersDialog");

    this.value = this.valueType == DiscountValueType.Time ? this.value * 60 * 60 : this.value; 

    var voucherResult = await this.Api.get<GenerateVoucherResult>("/Campaign/GenerateVouchers", { templateCode: this.campaign.DiscountCode, amount: this.counter, value: this.value, ValueType: this.valueType, partner: this.partner });
    await this.UI.openDialog("T4.Campaigns.GenerateVouchersResultDialog", { data: voucherResult });

    return true;
  }
}
